import { useEffect, useState } from "react";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import CustomButton from "../../../../components/CustomButton";
import ModalWrapper from "../../../../components/Modal/ModalWrapper";
import { postPrintRecallAwb } from "../../../../redux/api/recall.api";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  RecallAwbPrintDirection,
  RecallClientActionsDataInterface,
} from "../../../../redux/interfaces/recall.interface";
import { clearRecallAwbPrint } from "../../../../redux/reducer/recall.reducer";
import Text from "../../../../styleguide/Text";
import { isRecallAwbSent } from "./recallClientActionsHelper";

function RecallClientAwbPrintModal({
  client,
  handleClose,
}: {
  client: RecallClientActionsDataInterface;
  handleClose: () => void;
}) {
  const dispatch = useAppDispatch();
  const { data, isLoading, isError, errorMessage } = useAppSelector(
    (state) => state.recall.awbPrint,
  );
  const hasOutbound = isRecallAwbSent(client.awb);
  const hasReturn = isRecallAwbSent(client.awb?.returnAwb);
  const [direction, setDirection] = useState<RecallAwbPrintDirection>(
    hasOutbound && hasReturn ? "both" : hasOutbound ? "outbound" : "return",
  );
  const options: { value: RecallAwbPrintDirection; label: string }[] = [];
  if (hasOutbound) options.push({ value: "outbound", label: "AWB plic" });
  if (hasReturn) options.push({ value: "return", label: "AWB retur" });
  if (hasOutbound && hasReturn) options.push({ value: "both", label: "Toate" });
  const isAvailable = options.some((option) => option.value === direction);

  useEffect(() => {
    dispatch(clearRecallAwbPrint());
    return () => {
      dispatch(clearRecallAwbPrint());
    };
  }, [dispatch]);

  const handlePrint = () => {
    if (isLoading || !isAvailable) return;
    dispatch(
      postPrintRecallAwb({
        idCampaign: client.idCampaign,
        clientPlId: client.clientPlId,
        direction,
      }),
    );
  };

  return (
    <ModalWrapper
      show
      title="Imprima AWB"
      handleClose={isLoading ? undefined : handleClose}>
      <div className="flex flex-col gap-4">
        <Text>Alege ce imprimi pentru farmacia "{client.pharmacyName}".</Text>
        <RadioGroup
          aria-label="AWB pentru imprimare"
          value={direction}
          onChange={(event) => {
            setDirection(event.target.value as RecallAwbPrintDirection);
            dispatch(clearRecallAwbPrint());
          }}>
          {options.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              label={option.label}
              control={<Radio />}
              disabled={isLoading}
            />
          ))}
        </RadioGroup>
        {data && (
          <Text role="status">
            Etichete trimise catre imprimanta: {data.labelCount}. Verifica
            imprimarea fizica.
          </Text>
        )}
        {isError && (
          <Text role="alert" className="text-danger">
            {errorMessage}
          </Text>
        )}
        <div className="flex flex-wrap justify-between gap-3">
          <CustomButton
            variant="outlined"
            disabled={isLoading}
            onClick={handleClose}>
            {data ? "Inchide" : "Anuleaza"}
          </CustomButton>
          <CustomButton
            variant="contained"
            loading={isLoading}
            disabled={isLoading || !isAvailable}
            onClick={handlePrint}>
            {data ? "Imprima din nou" : "Imprima"}
          </CustomButton>
        </div>
      </div>
    </ModalWrapper>
  );
}

export default RecallClientAwbPrintModal;
